export const useNominationPageStore = defineStore("nominationPageStore", {
  state: () => ({
    showModal: false,
    dataModal: {},
  }),
  actions: {
    handleOpenPreview(participant) {
      this.dataModal = participant
      this.showModal = true
      document.querySelector("body").style.overflow = "hidden"
    },
    handleClosePreview() {
      this.showModal = false
      document.querySelector("body").style.overflow = "visible"
    },
  },
})
